<template>
  <v-menu
  v-model="menu"
  offset-y
  min-width="200"
  left>

    <template v-slot:activator="{ on }">
      <v-btn
        text
        v-on="on"
      >
        {{ label }}
        <v-icon small>keyboard_arrow_down</v-icon>
      </v-btn>
    </template>

    <!-- DROPDOWN -->
    <v-list>
      <v-list-item
      @click="selectedItem = null">
        <v-list-item-title
        :class="[{'color1--text' : !selectedItem}]">
          Default
        </v-list-item-title>
      </v-list-item>

      <v-list-item 
      v-for="(item, index) in listedMetrics" 
      :key="index" 
      @click="selectedItem = item">
        <v-list-item-title :class="[{ 'color1--text' : item === selectedItem}]">
          {{ item.name }}
        </v-list-item-title>
        <v-chip outlined :class="[{'color1--text' : item === selectedItem}]">
          {{ item.symbol }}
        </v-chip>
      </v-list-item>
    </v-list>

  </v-menu>
</template>

<script>
export default {
  props: {
    sid: {
      default: 'si-mass-g'
    }
  },
  data () {
    return {
      menu: false,
      selectedItem: null
    }
  },
  computed: {
    label () {
      if (this.selectedItem) {
        return this.selectedItem.symbol
      }
      return 'Auto'
    },
    listedMetrics () {
      // var comb = this.popupMetricSystemCode + '-' + this.popupMetricCode
      var sorted = this.$crx.metrics.metricTable.filter(item => {
        return item.sid.startsWith('si-mass')
      })
      return sorted
    }
  },
  watch: {
    selectedItem (nv) {
      if (nv) {
        this.$emit('update:sid', nv.sid)
      } else {
        this.$emit('update:sid', null)
      }
    }
  },
  created () {
    this.selectedItem = this.$crx.metrics.getMetricRowFromSid(this.sid)
  }
}
</script>
